// Dynamic API URL detection for mobile/desktop
const getApiBaseUrl = (): string => {
  if (process.env.REACT_APP_API_BASE_URL) {
    return process.env.REACT_APP_API_BASE_URL;
  }

  const hostname = window.location.hostname;
  // If accessing via IP address (e.g., from iPhone), use that IP for backend
  if (hostname !== 'localhost' && hostname !== '127.0.0.1') {
    return `http://${hostname}:8000`;
  }

  return "http://localhost:8000";
};

const getWsBaseUrl = (): string => {
  if (process.env.REACT_APP_WS_BASE_URL) {
    return process.env.REACT_APP_WS_BASE_URL;
  }

  const hostname = window.location.hostname;
  // If accessing via IP address (e.g., from iPhone), use that IP for WebSocket
  if (hostname !== 'localhost' && hostname !== '127.0.0.1') {
    return `ws://${hostname}:8000`;
  }

  return "ws://localhost:8000";
};

export const API_BASE_URL = getApiBaseUrl();
export const WS_BASE_URL = getWsBaseUrl();

// API endpoints
export const API_ENDPOINTS = {
  BASE: API_BASE_URL,
  LOGIN: `${API_BASE_URL}/api/v1/users/login`,
  REGISTER: `${API_BASE_URL}/api/v1/users/register`,
  VERIFY_EMAIL: `${API_BASE_URL}/api/v1/verify-email`,
  RESEND_VERIFICATION: `${API_BASE_URL}/api/v1/resend-verification`,
  USERS: `${API_BASE_URL}/api/v1/users`,
  USERS_INFO: `${API_BASE_URL}/api/v1/internal/users/info`,
  LINSTER_INFO: `${API_BASE_URL}/api/v1/users/info`,
  CONVERSATION: `${API_BASE_URL}/api/v1/internal/conversation`,
  CHAT: `${API_BASE_URL}/api/v1/internal/chat`,
  SCRAPE_PSYCHOLOGY_TODAY: `${API_BASE_URL}/api/v1/scrape/psychology-today`,
  UPDATE_THERAPIST_PROFILE: `${API_BASE_URL}/api/v1/internal/therapist/profile`,
  PAYMENT_CREATE_CHECKOUT: `${API_BASE_URL}/api/v1/internal/payment/create-checkout`,
  PAYMENT_VERIFY_SESSION: `${API_BASE_URL}/api/v1/internal/payment/verify-session`,
  PAYMENT_HISTORY: `${API_BASE_URL}/api/v1/internal/payment/history`,
  PAYMENT_REFUND: `${API_BASE_URL}/api/v1/internal/payment/refund`,
  UPLOAD_PROFILE_PHOTO: `${API_BASE_URL}/api/v1/internal/users/upload-profile-photo`,
};
